/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import * as S from './ExistingAudience.styled';
import { AppsFlyerIcon } from 'assets/icons';
import { ParagraphWithTooltip } from 'components';

const AudienceItem = ({
  cust_aud_number,
  cust_aud_name,
  partner_name,
  custom_audience_file_upload_el,
  custAudNumber,
  setSelectedAud,
  isChanged,
  search,
}) => {
  const handleChooseAudience = useCallback(() => {
    setSelectedAud({
      partnerName: partner_name,
      isAllApps: true,
      fileName: null,
      audienceName: cust_aud_name,
      isNewAudience: false,
      custAudNumber: cust_aud_number,
      fileAnalyzeMessage: custom_audience_file_upload_el.file_analyze_message,
      is_file_in_loading_process: custom_audience_file_upload_el.is_file_in_loading_process,
    });
    isChanged.current = false;
  }, []);

  return (
    <S.ItemContainer isSelected={cust_aud_number === custAudNumber} onClick={handleChooseAudience}>
      <S.ItemName>
        <ParagraphWithTooltip text={cust_aud_name} search={search} isHighlight={true} />
      </S.ItemName>
      {partner_name ? (
        <S.UploadedName>
          uploaded via <AppsFlyerIcon />
        </S.UploadedName>
      ) : null}
      {custom_audience_file_upload_el?.is_file_in_loading_process ? (
        <S.DevicesCount>processing...</S.DevicesCount>
      ) : (
        <S.DevicesCount>{custom_audience_file_upload_el.devices_count} devices</S.DevicesCount>
      )}
    </S.ItemContainer>
  );
};

export default AudienceItem;
